export const CONTROL_BOOKMARKS_QUERY = '/assessment/control-bookmarks';
export const SCOPING_ANSWERS_QUERY = '/assessment/scoping-answers';
